import Hero from "../sections/Hero";
import ServiceBento from "../sections/ServiceBento";
import MembershipsSection from "../sections/MembershipsSection";
import CannabisSection from "../sections/CannabisSection";
import AboutSection from "../sections/AboutSection";
import GallerySection from "../sections/GallerySection";
import TestimonialsSection from "../sections/TestimonialsSection";
import PricingSection from "../sections/PricingSection";
import VisitSection from "../sections/VisitSection";
import InstagramSection from "../sections/InstagramSection";

export default function Home() {
  return (
    <main>
      <Hero />
      <ServiceBento />
      <MembershipsSection />
      <CannabisSection />
      <AboutSection />
      <GallerySection />
      <TestimonialsSection />
      <PricingSection />
      <VisitSection />
      <InstagramSection />
    </main>
  );
}
